import React from 'react';

export const DotList: React.FC<{ items: string[] }> = ({ items }) => {
  const firstItems = items.slice(0, items.length - 1);
  const lastItem = items.slice(-1);

  return (
    <div style={{ marginBottom: '2.5rem' }}>
      <div style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            borderLeftWidth: '2px',
            borderLeftStyle: 'solid',
            borderLeftColor: 'white',
            top: '1.1rem',
            left: '0.3rem',
            bottom: '-1rem',
          }}
        />
        {firstItems.map((item, i) => {
          const isFirst = i === 0;
          return (
            <div
              key={i}
              style={{
                position: 'relative',
                display: 'flex',
                flexWrap: 'wrap',
                gap: '1.2rem',
                paddingBottom: '1.75rem',
              }}
            >
              <div
                style={{
                  marginTop: '.5rem',
                  borderRadius: '9999px',
                  borderWidth: '2px',
                  borderStyle: 'solid',
                  backgroundColor: isFirst ? '#4ade80' : '#2563eb',
                  borderColor: isFirst ? '#4ade80' : 'white',
                  width: '.75rem',
                  height: '.75rem',
                  ...(isFirst ? { animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' } : {}),
                }}
              />
              <div
                style={{ width: 'calc(100% - 3.5rem)' }}
                // eslint-disable-next-line @typescript-eslint/naming-convention
                dangerouslySetInnerHTML={{ __html: item }}
              />
            </div>
          );
        })}
      </div>
      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '1.2rem',
        }}
      >
        <div
          style={{
            marginTop: '.5rem',
            borderRadius: '9999px',
            borderWidth: '2px',
            borderStyle: 'solid',
            backgroundColor: '#2563eb',
            borderColor: 'white',
            width: '.75rem',
            height: '.75rem',
          }}
        />
        {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
        <div style={{ width: 'calc(100% - 3.5rem)' }} dangerouslySetInnerHTML={{ __html: lastItem }} />
      </div>
    </div>
  );
};
